// extracted by css-extract-rspack-plugin
export default {"link":"_94259c17"};